import React from 'react';
import { Controller } from 'react-hook-form';
import { MarketCheckbox, MarketRow } from '@market/react';

const ControlledCheckbox = (props) => {
  const {
    // fields used by Controller
    name,
    control,
    defaultValue = false,
    rules,
    shouldUnregister = false,

    // fields used by Market
    label,
    disabled = false,
    controlPosition = 'leading',
    onValueChange = () => {},
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({
        field: { onChange, value },
        fieldState: { invalid },
        formState: { isSubmitting, isValidating },
      }) => (
        <MarketRow
          interactive
          name={name}
          controlPosition={controlPosition}
          onMarketRowSelected={() => {
            onChange(true);
            onValueChange(true);
          }}
          onMarketRowDeselected={() => {
            onChange(false);
            onValueChange(false);
          }}
          {...((disabled || isSubmitting || isValidating) && {
            disabled: true,
          })}
          selected={value}
        >
          <MarketCheckbox
            slot="control"
            {...(value && { checked: true })}
            {...(invalid && { invalid: true })}
          />
          {label}
        </MarketRow>
      )}
    />
  );
};

export default ControlledCheckbox;
